import { isFeatureEnabled } from '@lumapps/features';
import { getCurrentInstanceName, getCurrentInstanceParentId } from '@lumapps/instance/ducks/selectors';
import { NavigationHeaderProps } from '@lumapps/lumx-back-office/components/NavigationHeader/NavigationHeader';
import { createSelector } from '@lumapps/redux/reselect';

import { DISPLAY_PUBLIC_NAVIGATION_TOKEN } from '../constants';

export const isDisplayPublicNavigationFeatureFlagEnabled = isFeatureEnabled(DISPLAY_PUBLIC_NAVIGATION_TOKEN);

const isMainNavInheritanceFeatureFlagEnabled = isFeatureEnabled('main-nav-inheritance');

export const getBackofficeNavigationHeader = createSelector(
    getCurrentInstanceName,
    getCurrentInstanceParentId,
    isMainNavInheritanceFeatureFlagEnabled,
    (name, parentInstance, isMainNavInheritanceEnabled) => {
        return {
            siteName: name,
            parentInstance,
            isMainNavInheritanceEnabled,
        } as NavigationHeaderProps;
    },
);

export const isMainNavInheritanceEnabled = createSelector(
    isMainNavInheritanceFeatureFlagEnabled,
    getCurrentInstanceParentId,
    (isFeatureFlagEnabled, currentInstanceParentId) => {
        return isFeatureFlagEnabled && Boolean(currentInstanceParentId);
    },
);
